import { send } from 'server';
import * as Types from './types';

export const getForcedLossLimits = (): Promise<Types.IGetForcedLossLimits> => send({
    ID: 35856,
    responses: [35857, 35858],
    description: 'Get forced loss limits',
    errorLevel: 1
});
